import ListLetterContentComponent from '../components/letter_content/ListComponent'
import CreateLetterContentComponent from '../components/letter_content/CreateComponent'
import ViewLetterContentComponent from '../components/letter_content/ViewComponent'
import EditLetterContentComponent from '../components/letter_content/EditComponent'
import LetterEditComponent from '../components/letters/Edit'
import ReportComponent from '../components/report/Report'
import InvoiceListComponent from '../components/invoice/ListComponent.vue'
import InvoicePreviewComponent from '../components/invoice/PreviewComponent.vue'
import InvoiceCreateComponent from '../components/invoice/CreateComponent.vue'
import InvoiceEditComponent from '../components/invoice/EditComponent.vue'
import CustomLetterComponent from '../components/CustomLetterComponent.vue'
import DiyDashboard from '../components/dashboard/DiyDashboard.vue'
import BusinessDashboard from '../components/dashboard/BusinessDashboard.vue'
import AdminDashboard from '../components/admin_dashboard/AdminDashboard.vue'
import AdminUserView from '../components/admin_dashboard/admin_user_view/AdminUserView.vue'
import CreditContactListComponent from '../components/credit_contact/ListComponent.vue'
import CreditContactCreateComponent from '../components/credit_contact/CreateComponent.vue'
import CreditContactPreviewComponent from '../components/credit_contact/PreviewComponent.vue'
import CreditContactEditComponent from '../components/credit_contact/EditComponent.vue'
import ThirtyDayReport from '../components/report/ThirtyDayReport.vue'
import ClientPipeline from '../components/business/opportunities/pipeline/ClientPipeline.vue'
import Mails from '../components/mail/Mails.vue'
import ShowMail from '../components/mail/Show.vue'
import StatisticsMail from '../components/mail/Statistics.vue'
import IndexComponent from '../components/profile/IndexComponent.vue'
import KnowledgeBaseComponent from '../components/knowledge_base/KnowledgeBaseComponent.vue'
import KnowledgeBaseVideo from '../components/knowledge_base/KnowledgeBaseVideo.vue'
import BlogComponent from '../components/blogs/BlogComponent.vue'
import BlogContentComponent from '../components/blogs/BlogContentComponent.vue'
import FaxHistory from '../components/clicksend/FaxHistory'
import LobLetter from '../components/LobLetter.vue'
import AttackHistoryComponent from '../components/dispute/AttackHistory.vue'
import DisputeReportComponent from '../components/dispute/Report.vue'
import EmailHistory from '../components/clicksend/EmailHistoryViewComponent.vue'
import OrderHistoriesComponent from '../components/OrderHistoriesComponent.vue'
import ReferralsComponent from '../components/referrals/ReferralsComponent.vue'
import DiySettingsComponent from '../components/settings/DiySettingsComponent.vue'
import PricingPlansComponents from '../components/PlansComponent.vue'
import BillingComponent from '../components/billing/BillingComponent.vue'
import AuthorizedUsersComponent from '../components/user/AuthorizedUsersComponent.vue'
import FamilyDashboard from '../components/family/FamilyDashboard'
import DisputeLetterViewComponent from  '../components/letters/layouts/DisputeLetterViewComponent.vue'
import LetterTutorial from '../components/letters/components/LetterTutorial.vue'
import Chat from '../components/chat/Index.vue'
import ClientDetail from '../components/ClientDetail.vue'
import TeamDashboard from '../components/team/dashboard/TeamDashboard'
import UserEbookProducts from '../components/Home/Landing/UserEbookProducts.vue'
import Messages  from '../components/messages/MessagesComponent.vue'
import UserTable from '../components/admin_dashboard/UserTable.vue';
import CreateBlogComponent from '../components/blogs/CreateBlogComponent.vue'
import ClientDashboard from '../components/client/DashboardComponent.vue';
import ClientPlan from '../components/client/PlanComponent.vue';
import ClientDetailComponent from '../components/client/ClientDetailComponent.vue';
import ClientCreditAnalysisCompent from '../components/client/ClientCreditAnalysisCompent.vue';
import CreditAnalysis from '../components/report/CreditAnalysis.vue'
import HomeComponent from '../components/HomeComponent.vue'
import BlackFridayCompent from '../components/BlackFridayComponent.vue'
import StartComponent from '../components/Home/StartComponent.vue'
import CustomLetterCreateComponent from '../components/CustomLetterCreateComponent.vue'
import EducationComponent from '../components/Education/EducationComponent.vue'
import CoursesComponent from '../components/Education/courses/CoursesComponent.vue'
import CoursesCreateComponent from '../components/Education/courses/admin/CoursesCreateComponent.vue'
import UpdateCourseComponent from '../components/Education/courses/admin/UpdateCourseComponent.vue'
import AdminCoursesComponent from '../components/Education/courses/admin/AdminCoursesComponent.vue'
import CreateLessonComponent from '../components/Education/courses/lessons/CreateLessonComponent'
import LearnContent from '../components/Education/courses/LearnContent'
import GuestLearnContent from '../components/Education/courses/guest/GuestLearnContent'
import UserCoursesComponent from '../components/Education/courses/UserCoursesComponent.vue'
import LoginPage from '../components/auth/LoginPage.vue'
import RegisterPage from '../components/auth/RegisterPage.vue'
import GuestCoursesComponent from '../components/Education/courses/guest/CourseListComponent.vue'
import YearEndSaleCompent from '../components/YearEndSaleCompent.vue'
import BlogEditComponent from '../components/blogs/BlogEditComponent.vue'
import PowerOfAttorney from '../components/client/ContractInfoComponent.vue'

const routes = [
    {
        path: '/admin/letter-content',
        component: ListLetterContentComponent,
        name: 'list-letter-content'

    },
    {
        path: '/admin/letter-content/create',
        component: CreateLetterContentComponent,
        name: 'create-letter-content'
    },
    {
        path: '/admin/letter-content/:letter_content',
        component: ViewLetterContentComponent,
        name: 'view-letter-content'
    },
    {
        path: '/admin/letter-content/:letter_content/edit',
        component: EditLetterContentComponent,
        name: 'edit-letter-content'
    },
    {
        path: '/disputes/letterEdit/:letter_user/:client?/:team?',
        component: LetterEditComponent,
        name: 'letter-edit'
    },
    {
        path: '/client/:client/user/:team?',
        component: ClientDetail,
        name: 'report'
    },
    {
        path: '/invoice/list',
        component: InvoiceListComponent,
        name: 'invoice-list'
    },
    {
        path: '/invoice/listAjax/:client?',
        name: 'invoice-list-ajax'
    },
    {
        path: '/invoice/preview/:invoice',
        component: InvoicePreviewComponent,
        name: 'invoice-preview'
    },
    {
        path: '/invoice/add',
        component: InvoiceCreateComponent,
        name: 'invoice-create'
    },
    {
        path: '/invoice/debt-collectors/:client?',
        name: 'invoice-debt-collectors'
    },
    {
        path: '/invoice/save/:client?/:team?',
        name: 'invoice-save'
    },
    {
        path: '/invoice/download/:invoice',
        name: 'invoice-download'
    },
    {
        path: '/invoice/delete/:id',
        name: 'invoice-delete'
    },
    {
        path: '/invoice/edit/:invoice',
        component: InvoiceEditComponent,
        name: 'invoice-edit'
    },
    {
        path: '/invoice/add/debt-collector/:client?',
        name: 'invoice-add-debt-collector'
    },
    {
        path: '/disputes/spin/letter',
        name: 'spin-letter'
    },
    {
        path: '/disputes/letter/create/:letter/:client?/:team?',
        name: 'create-letter'
    },
    {
        path: '/disputes/creditBureau/:type/:letter/:client?/:team?',
        name: 'disputes-creditBureau'
    },
    {
        path: '/disputes/affidavitletter/categories',
        name: 'affidavitletter-categories'
    },
    {
        path: '/disputes/:letter/:client?/:team?',
        component: DisputeLetterViewComponent,
        name: 'dispute-letter'
    },
    {
        path: '/login',
        component: LoginPage,
        name: 'login'
    },
    {
        path: '/dashboard/letters/:client?/:team?',
        name: 'dashboard-letters'
    },
    {
        path: '/disputes/center/letters/:type',
        name: 'dispute-center-letters'
    },
    {
        path: '/disputes/edit/:letter',
        component: CustomLetterComponent,
        name: 'disputes-letter-edit'
    },
    {
        path: '/knowledge/center',
        component :KnowledgeBaseComponent,
        name: 'knowledge-center'
    },
    {
        path: '/disputes/attacks/:client?/:team?',
        name: 'disputes-attacks'
    },
    {
        path: '/disputes/report/:client?/:team?',
        component : DisputeReportComponent,
        name: 'disputes-report'
    },
    {
        path: '/disputes/attacks/:attack/:client?/:team?',
        name: 'attack-delete'
    },
    {
        path: '/disputes/attacks/bulk-destroy',
        name: 'attacks-bulk-destroy'
    },
    {
        path: '/disputes/attacks/:attack/zip/:client?/:team?',
        name: 'attacks-zip'
    },
    {
        path: '/disputes/attacks/:attack/letters',
        name: 'attacks-letters'
    },
    {
        path: '/disputes/attacks/history',
        component: AttackHistoryComponent,
        name: 'attacks-history'
    },
    {
        path: '/disputes',
        name: 'disputes'
    },
    {
        path: '/disputes/add',
        component: CustomLetterCreateComponent,
        name: 'disputes-letter-add'
    },
    {
        path: '/disputes/letterTutorial/:letter/:client?/:team?',
        component: LetterTutorial,
        name: 'disputes-letter-tutorial'
    },
    {
        path: '/disputes/delete/:letter',
        name: 'disputes-letter-delete'
    },
    {
        path: '/user/:client?/:team?',
        name: 'user'
    },
    {
        path: '/fetch-letters',
        name: 'fetch-letters'
    },
    {
        path:'/import/client',
        name:'import-client'
    },
    // simple diy routes done
    {
        path: '/dashboard/authorized-user',
        component:AuthorizedUsersComponent,
        name: 'authorized-user'
    },
    {
        path: '/account',
        component: IndexComponent,
        name: 'user-account',
    },
    {
        path: "/subscriptions/plans",
        component: PricingPlansComponents,
        name: "billing-plans"
    },
    {
        path: "/subscriptions/coupon",
        name: "billing-coupon"
    },
    {
        path:"/subscriptions/plan",
        component: BillingComponent,
        name:"billing-subscriptions-plan"
    },
    {
        path:"/subscriptions/invoices",
        name:"billing-subscriptions-invoices"
    },
    {
        path: "/subscriptions/invoice/:id",
        name: "billing-subscriptions-invoice"
    },
    {
        path:"/subscriptions/checkout",
        name:"billing-subscriptions-store"
    },
    {
        path:"/blog/:category?",
        component: BlogComponent,
        name:"blogs"
    },
    {
        path: "/blog/create",
        component: CreateBlogComponent,
        name: "blog-create"
    },
    {
        path: "/blog/save",
        name: "blog-save"
    },
    {
        path:"/blog/:category/:slug",
        component: BlogContentComponent,
        name:"blog-category-content"
    },
    {
        path:"/blog/:category/:slug/edit",
        component:BlogEditComponent,
        name:"post-edit"
    },
    {
        path:"/blog/search",
        name:"blog-search"
    },
    {
        path:"/blog/update",
        name:"blog-update"
    },
    {
        path:"/comment/save",
        name:"comment-store"
    },
    {
        path:"/comment/:id",
        name:"comment-delete"
    },
    {
        path:"/credit-contact/list/:client?/:team?",
        component: CreditContactListComponent,
        name: "credit-contact-index"
    },
    {
        path: '/credit-contact/create/:client?/:team?',
        component: CreditContactCreateComponent,
        name: 'credit-contact-create'
    },
    {
        path: '/credit-contact/:credit_contact/show/:team?',
        component: CreditContactPreviewComponent,
        name: 'credit-contact-preview'
    },
    {
        path: '/credit-contact/store/:client?/:team?',
        name: 'credit-contact-store'
    },
    {
        path: '/credit-contact/:credit_contact/edit/:team?',
        component: CreditContactEditComponent,
        name: 'credit-contact-edit'
    },
    {
        path: '/credit-contact/:credit_contact/delete',
        name: 'credit-contact-delete'
    },
    {
        path: '/credit-contact/:credit_contact/update/:team?',
        name: 'credit-contact-update'
    },
    {
        path:"/creditreport/:client?/:team?",
        component: ReportComponent,
        name:"credit-report"
    },
    {
        path:"/disputes",
        name:"dispute-center"
    },
    {
        path:"/disputes/report",
        component : DisputeReportComponent,
        name:"dispute-report"
    },
    {
        path:"/dashboard",
        component : DiyDashboard,
        name:"diy-dashboard"
    },
    {
        path:"/dashboard/business",
        component : BusinessDashboard,
        name:"company"
    },
    {
        path: "/email/history",
        component: EmailHistory,
        name: "email-history"
    },
    {
        path:"/family",
        component:FamilyDashboard,
        name:"family-index"
    },
    {
        path:"/family/join",
        name:"family-join"
    },
    {
        path: '/family/member/:invite/resend/code',
        name: 'family-member-resend-code'
    },
    {
        path: '/family/member/:invite/regenerate/code',
        name: 'family-member-regenerate-code'
    },
    {
        path: '/:family/member/:user/delete',
        name: 'family-member-delete'
    },
    {
        path: '/member/invite/delete/:invite',
        name: 'family-member-invite-delete'
    },
    {
        path: '/member/:invite/resend/email',
        name: 'family-member-resend-email'
    },
    {
        path: '/family/:family/delete',
        name: 'family-delete'
    },
    {
        path: '/family/details',
        name: 'family-get'
    },
    {
        path: '/family/:family/member',
        name: 'family-member'
    },
    {
        path: '/family/:family/edit',
        name: 'family-edit'
    },
    {
        path:"/fax/history",
        component :FaxHistory,
        name:"fax-history"
    },
    {
        path:"/getcreditanalysis",
        component :ClientCreditAnalysisCompent,
        name:"get-credit-analysis"
    },
    // check this here
    {
        path:"/knowledge/center",
        component :KnowledgeBaseComponent,
        name:"knowledge-base-index"
    },
    {
        path:"/knowledge/center/:slug/all/videos",
        component :KnowledgeBaseVideo,
        name:"knowledge-center-videos"
    },
    {
        path:"/disputes/letter/zip/download/:id",
        name:"letter-zip-download-url"
    },
    {
        path:"/lob-letter",
        component: LobLetter,
        name:"lob-letter-view"
    },
    {
        path:"/logout",
        name:"logout"
    },
    {
        path:"/logout_link",
        name:"logout-link"
    },
    {
        path:"/logout",
        name:"logout"
    },
    {
        path:"/notifications/:notification",
        name:"notification-delete-url"
    },
    {
        path:"/notifications/:notificationId",
        name:"notification-single-mark-as-read-url"
    },
    {
        path:"/notifications",
        name:"notification-url"
    },
    {
        path:"/notifications/read",
        name:"notifications-mark-as-read-url"
    },
    {
        path:"/dashboard/order-history",
        component:OrderHistoriesComponent,
        name:"order-history"
    },
    {
        path:"/referrals/refer",
        component: ReferralsComponent,
        name:"referrals"
    },
    {
        path:"/settings",
        component: DiySettingsComponent,
        name:"settings"
    },
    {
        path:"/teams",
        component: TeamDashboard,
        name:"team-index"
    },
    {
        path:"/admin/client",
        name:"client-index"
    },
    {
        path:"/admin/client",
        name:"client-index"
    },
    {
        path : '/client/image/save/:client?/:team?',
        name : 'image-save'
    },
    {
        path : '/client/image/delete/:client?/:team?',
        name : 'image-delete'
    },
    {
        path : '/account/update',
        name : 'account-update'
    },
    {
        path : '/fetch-report/:client?/:team?',
        name : 'fetch-report'
    },
    {
        path : '/login-attempt/:client?/:team?',
        name : 'login-attempt'
    },
    {
        path : '/account/updateSmartCreditInfo/:client?/:team?',
        name : 'update-smart-credit-info'
    },
    {
        path : '/client/identity-iq/update/:client?/:team?',
        name : 'identity-iq'
    },
    {
        path : '/account/update-creditfixrr-reports-credentials/:client?/:team?',
        name : 'update-creditfixrr-reports-credentials'
    },
    {
        path : '/fetch-creditfixrr-report/:client?/:team?',
        name : 'fetch-creditfixrr-report'
    },
    {
        path : '/getreport/:client?/:team?',
        name : 'getreport'
    },
    {
        path : '/checkcreds/:client?/:team?',
        name : 'checkcredentials'
    },
    {
        path : '/disputes/letterEmail/:id/:client?/:team?',
        name : 'letter-email'
    },
    {
        path : '/disputes/letter/fax/number/:client?/:team?',
        name : 'fax-number'
    },
    {
        path : '/disputes/letter/fax/:letterUser/:client?/:team?',
        name : 'fax-send'
    },
    {
        path : '/disputetracker/date/:client?/:team?',
        name : 'disputer-tracker-date'
    },
    {
        path : '/dashboard/update_letter_status/:letterUser/:client?/:team?',
        name : 'update-letter-status'
    },
    {
        path : '/disputetracker/status/:client?/:team?',
        name : 'update-status-url'
    },
    {
        path : '/dashboard/deleteletter/:client?/:team?',
        name : 'delete-letter'
    },
    {
        path : '/dashboard/bulk_delete_letter/:client?/:team?',
        name : 'bulk-delete-letter'
    },
    // {
    //     path : '/disputes/letterEdit/:letterUser/:client?/:team?',
    //     name : 'letter-edit-url'
    // },
    {
        path : '/disputes/letterDownload/:letterUser/:client?/:team?',
        name : 'letter-download-url'
    },
    {
        path : '/disputes/letter/zip/generate/:client?/:team?',
        name : 'letter-zip-generate'
    },
    {
        path : '/disputes/fetch/letter/:letterUser/:client?/:team?',
        name : 'fetch-letter-page'
    },
    {
        path : '/lobmailer/:client?/:team?',
        name : 'lob-mailer'
    },
    {
        path : '/disputes/checkValidUserDispute/:client?/:team?',
        name : 'check-valid-user-dispute'
    },
    {
        path : '/dashboard/business/company/store',
        name : 'company-store'
    },
    {
        path : '/settings/email/update',
        name : 'email-setting-update'
    },
    {
        path : '/settings/store',
        name : 'lob-settings'
    },
    {
        path : '/settings/lob',
        name : 'lob-setting'
    },
    {
        path : '/settings/default',
        name : 'default-settings'
    },
    {
        path : '/dashboard/business/company/sms_fax/store',
        name : 'sms-fax-settings'
    },
    {
        path : '/settings/fax/store',
        name : 'fax-setting'
    },
    {
        path : '/dashboard/business/company/affiliiate/store',
        name : 'company-affiliate-setting-update'
    },
    {
        path : '/dashboard/business/company/contract/setting/store',
        name : 'company-contract-setting-update'
    },
    {
        path : '/dashboard/business/company/recurly/setting/store',
        name : 'company-recurly-setting-update'
    },
    {
        path : '/get/list/client/:userid?',
        name : 'get-client-list'
    },
    {
        path: '/client/status/update/:team?',
        name : 'client-status-update'
    },
    {
        path: '/client/assigned/:team?',
        name : 'client-assign-update'
    },
    {
        path: '/client/send/email/:team?',
        name : 'client-send-email'
    },
    {
        path : '/client/send/company-url/:client/:team?',
        name : 'client-send-url'
    },
    {
        path : '/client/send/sms/:team?',
        name : 'client-send-sms'
    },
    {
        path : '/client/:client/:team?',
        name : 'client-delete'
    },
    {
        path : '/admin/client',
        name:'admin-create-client'
    },
    {
        path : '/client/dashboard',
        component: ClientDashboard,
        name : "client-dashboard"
    },
    {
        path: '/client/plans',
        component: ClientPlan,
        name: "client-plans"
    },
    {
        path: '/client/subscribe',
        name: "client-subscribe"
    },
    {
        path: '/client/subscription/terminate',
        name: "client-subscription-terminate"
    },
    {
        path : '/teams/:team/list/clients',
        name : "team-client-list"
    },
    {
        path:'/administrant/dashboard',
        component:AdminDashboard,
        name:'super-admin-dashboard'
    },
    {
        path:'/list/users/:user?',
        component: UserTable,
        name:'create-user'
    },
    {
        path:'/administrant/user/:user',
        component:AdminUserView,
        name:'user-show'
    },
    {
        path:'/administrant/disputeletter/user/:user',
        name:'admin-dispute_tracker'
    },
    {
        path:'/administrant/:user/update/email-status',
        name:'update-email-status'
    },
    {
        path:'/administrant/dashboard/userslist',
        name:'admin-users-list'
    },
    {
        path:'/administrant/search/user',
        name:'admin-search-user'
    },
    {
        path:'/rbac/get/roles/list',
        name:'admin-get-role-list'
    },
    {
        path:'/register',
        component: RegisterPage,
        name:'register'
    },
    {
        path:'/password/reset',
        name:'reset-password'
    },
    {
        path:'/states',
        name:'states'
    },
    {
        path:'/app/status',
        name:'app-status'
    },
    {
        path:'/client/login',
        name:'client-login'
    },
    {
        path: '/js/localization.js',
        name: 'localization'
    },
    {
        path: '/profile',
        name: 'profile'
    },
    {
        path: '/account/updateSSN/:client?/:team?',
        name: 'update-ssn'
    },
    {
        path: '/client/:client/user-store/:team?',
        name: 'update-client-profile'
    },
    {
        path: '/client/detail',
        component:ClientDetailComponent,
        name: 'client-dashboard-detail'
    },
    {
        path:'/create/access_token',
        name:'create-access-token'
    },
    {
        path:'/show/personal-access-tokens',
        name:'personal-access-tokens'
    },
    {
        path:'/oauth/personal-access-tokens/:tokenId',
        name:'delete-access-token'
    },
    {
        path:'/api-key/show/api-keys',
        name:'show-api-key-settings'
    },
    {
        path:'/api-key/save/api-keys',
        name:'save-api-key-settings'
    },
    {
        path: '/',
        component: HomeComponent,
        name: 'landing-page'
    },
    {
        path: '/blackfriday',
        component: BlackFridayCompent,
        name: 'black-friday-landing'
    },
    {
        path: '/yearendsale',
        component: YearEndSaleCompent,
        name: 'black-friday-landing'
    },
    {
        path: '/start',
        component: StartComponent,
        name: 'start-page'
    },
    {
        path:'/deactivate/reasons',
        name:'deactivate-reasons'
    },
    {
        path:'/subscriptions/cancel',
        name:'cancel-subscriptions'
    },
    {
        path: '/teams',
        name: 'store-teams'
    },
    {
        path: '/teams/:team/users/:user',
        name: 'destroy-teams-users'
    },
    {
        path: '/teams/:team',
        name: 'destroy-teams'
    },
    {
        path: '/teams/:team/edit',
        name: 'edit-teams'
    },
    {
        path: '/teams/:team/invite',
        name: 'teams-invite'
    },
    {
        path: '/teams/:team/users/:user/leave',
        name: 'teams-users-leave'
    },
    {
        path: '/teams/invite/:invite/delete',
        name: 'teams-invite-delete'
    },
    {
        path: '/teams/:team/user/:invite/resend/email',
        name: 'teams-invite-resend-email'
    },
    {
        path: '/teams/:team/user/:invite/resend/code',
        name: 'teams-invite-resend-code'
    },
    {
        path: '/teams/member/join',
        name: 'team-member-join'
    },
    {
        path: '/teams/member/:invite/regenerate/code',
        name: 'team-member-regenerate-code'
    },
    {
        path: '/teams/:team/permissions/store',
        name: 'teams-permissions-store'
    },
    {
        path: '/teams/:team/permissions',
        name: 'teams-permissions'
    },
    {
        path: '/purchase/attach-card',
        name: 'purchase-attach-card'
    },
    {
        path: '/purchase/top-up/:client?/:team?',
        name: 'purchase-top-up'
    },
    {
        path: '/purchase/add-card',
        name: 'purchase-add-card'
    },
    {
        path: '/purchase/delete-card',
        name: 'purchase-delete-card'
    },
    {
        path: '/purchase/default-card',
        name: 'purchase-default-card'
    },
    {
        path: '/30-day-report',
        component: ThirtyDayReport,
        name: 'thirty-day-report'
    },
    {
        path: '/settings/admin',
        name: 'admin-settings'
    },
    {
        path: '/opportunities',
        name: 'opportunities.show'
    },
    {
        path: '/opportunities/pipeline',
        component:ClientPipeline,
        name: 'opportunities.pipeline'
    },
    {
        path: '/opportunities/pipeline/list/clients',
        name: 'pipeline.show.client'
    },
    {
        path: '/opportunities/pipeline/add/clients',
        name: 'pipeline.add.client'
    },
    {
        path: '/opportunities/list',
        name: 'opportunities.show.list'
    },
    {
        path: '/opportunities/pipeline/show/:client',
        name: 'pipeline.client.details'
    },
    {
        path: '/opportunities/pipeline/update/:client',
        name: 'pipeline.update.client'
    },
    {
        path: '/opportunities/pipeline/show/activity/:client',
        name: 'pipeline.show.activity'
    },
    {
        path: '/opportunities/pipeline/dispute/activity/:client',
        name: 'pipeline.dispute.activity'
    },
    {
        path: '/opportunities/pipeline/destroy/:client',
        name: 'pipeline.destroy.client'
    },
    {
        path: '/contract-info',
        name: 'contract-info'
    },
    {
        path: '/power-of-attorney',
        component:PowerOfAttorney,
        name: 'power-of-attorney'
    },

    {
        path:"/uploadsignature",
        name:"client-uploadsignature",
    },
    {
        path: '/administrant/gohighlevel/settings',
        name: 'gohighlevel-settings'
    },
    {
        path: '/administrant/gohighlevel/generate/access-token',
        name: 'generate-gohighlevel-access-token'
    },
    {
        path: '/mails/list/:client?/:team?',
        component: Mails,
        name:'mails-list'
    },
    {
        path: '/mails/show/:mail/:client?/:team?',
        component: ShowMail,
        name: 'mail-show'
    },
    {
        path: '/mails/statistics',
        component: StatisticsMail,
        name: 'mails-statistics'
    },
    {
        path: '/mails/:mail/cancel/:client?/:team?',
        name: 'mails-cancel'
    },
    {
        path: '/mails/:mail/:client?/:team?',
        name: 'mails-destroy'
    },
    {
        path: '/purchase/spin',
        name: 'purchase-spin'
    },
    {
        path: '/current-date',
        name:'current-date'
    },
    {
        path: '/disputes/letterPreview/:letter',
        name: 'preview-dispute-letter'
    },
    {
        path:'/account/referral',
        name:'refer_user'
    },
    {
        path:'/account/affiliate/save',
        name:'save_affiliate_link'
    },
    {
        path:'/referrals/list',
        name:'referral_list'
    },
    {
        path:'/referrals/resend/invite',
        name:'referral_resend'
    },
    {
        path:'/referrals/delete/invite',
        name:'referral_delete'
    },
    {
        path:'/referrals/affiliate/stats',
        name:'affiliate_stats'
    },
    {
        path:'/referrals/affiliate/referrals',
        name:'affiliate_referrals'
    },
    {
        path:'/referrals/affiliate/referral',
        name:'affiliate_referral'
    },
    {
        path:'/socialshare',
        name:'socialshare'
    },
    {
        path: '/products',
        component:UserEbookProducts,
        name: 'products'
    },
    {
        path: '/chat',
        component: Chat,
        name: 'chat-index'
    },
    {
        path: '/chat/:chat',
        name: 'chat'
    },
    {
        path: '/chat/:chat/update',
        name: 'chat-update'
    },
    {
        path: '/chat/create',
        name: 'chat-create'
    },
    {
        path: '/chat/:chat/message',
        name: 'chat-send-message'
    },
    {
        path: '/disputes/creditors',
        name: 'fetch-creditors'
    },
    {
        path: '/account/uploads',
        name: 'upload-images'
    },
    {
        path: '/oauth/scopes',
        name: 'passport-scopes-index'
    },
    {
        path: '/disputetracker/:letterUser/upload-documents',
        name: 'disputertracker-upload-documents'
    },
    {
        path: '/disputetracker/:letterUser/documents',
        name: 'disputertracker-documents'
    },
    {
        path: '/disputetracker/:letterUser/documents',
        name: 'disputertracker-documents-delete'
    },
    {
        path: '/disputetracker/:letterUser/download/documents',
        name: 'disputertracker-documents-download'
    },
    {
        path: '/account/update/credit-monitoring-agency/:client?/:team?',
        name: 'update-credit-monitoring-agency'
    },
    {
        path: '/messages',
        component: Messages,
        name: 'messages'
    },
    {
        path: '/room/list/:client?',
        name: 'rooms'
    },
    {
        path: '/messages/:room',
        name: 'conversations'
    },
    {
        path: '/messages/send/:room/user/:client',
        name: 'business-send'
    },
    {
        path: '/messages/send/:room',
        name: 'user-to-user-send'
    },
    {
        path: '/user',
        name: 'fetch-client'
    },
    {
        path: '/client/messages',
        component:Messages,
        name: 'client-message'
    },
    {
        path: '/messages/read/:room',
        name: 'mark-read'
    },
    {
        path: '/messages/create',
        name: 'create-message'
    },
    {
        path: '/client/search',
        name: 'search-client'
    },
    {
        path: '/room/create/:client/:team?',
        name: 'new-message'
    },
    {
        path: '/room/:room/delete',
        name: 'delete-room'
    },
    {
        path: '/client/messages',
        component:Messages,
        name: 'client-messages'
    },
    {
        path: '/messages/chat/:user',
        name: 'single-conversations'
    },
    {
        path: '/room/new/messages',
        name: 'check-new-message'
    },
    {
        path: '/administrant/dashboard/monthly/signupstats',
        name: 'admin-monthly-signup-stats'
    },
    {
        path: '/administrant/dashboard/iqcreditreport',
        name: 'admin-getactiveiqcredit'
    },
    {
        path:"/dashboard/download/credit-analysis-report",
        name:"download-credit-analysis-report"
    },
    {
        path:"/client/detail",
        component:ClientDetailComponent,
        name:"client-detail"
    },
    {
        path:"/client/creditreport",
        component: ReportComponent,
        name:"creditreport"
    },
    {
        path:"/client/logout",
        name:"client-logout"
    },
    {
        path: '/subscriptions/resume',
        name: 'billing-subscriptions-resume'
    },
    {
        path: '/contract/download/:client/:type?/:team?',
        name: 'download-contract'
    },
    {
        path: '/academy',
        component:EducationComponent,
        name: 'academy'
    },
    {
        path: '/administrant/academy',
        name: 'admin-course-dashboard'
    },
    {
        path: '/academy/courses',
        component:CoursesComponent,
        name: 'courses'
    },
    {
        path: '/academy/courses-public',
        component:GuestCoursesComponent,
        name: 'courses-guest'
    },
    {
        path: '/academy/course/:course',
        component:LearnContent,
        name: 'courses-content'
    },
    {
        path: '/academy/course-guest/:course',
        component:GuestLearnContent,
        name: 'courses-content-guest'
    },
    {
        path: '/academy/course/create',
        component:CoursesCreateComponent,
        name: 'courses-create'
    },
    {
        path: '/academy/edit/:course',
        component:UpdateCourseComponent,
        name: 'course-edit'
    },
    {
        path: '/academy/admin/courses',
        component:AdminCoursesComponent,
        name: 'admin-courses'
    },
    {
        path: '/academy/update/:course',
        name: 'course-update'
    },
    {
        path: '/academy/delete/:course',
        name: 'course-delete'
    },
    {
        path:'/academy/course/search/course',
        name:'search-courses'
    },
    {
        path: '/academy/course/:course/lesson/create',
        component:CreateLessonComponent,
        name: 'lesson-create'
    },
    {
        path: '/academy/course/:course/lesson/:lesson/delete',
        name: 'lesson-delete'
    },
    {
        path: '/academy/course/:course/lesson/:lesson/update',
        name: 'lesson-update'
    },
    {
        path: '/academy/course/:course/lesson',
        name: 'course-lessons'
    },
    {
        path: '/academy/course/:lesson/lesson/video/save',
        name: 'lecture-create'
    },
    {
        path: '/lesson/:lesson/video/:video/delete',
        name: 'lecture-delete'
    },
    {
        path: '/lesson/:lesson/video/:video/upload',
        name: 'lecture-video-upload'
    },
    {
        path: '/lesson/:lesson/video/:video/update',
        name: 'lecture-update'
    },
    {
        path: '/lesson/:lesson/:video/delete',
        name: 'lecture-delete-video'
    },
    {
        path: '/lesson/:lesson/resource/:video/delete',
        name: 'lecture-delete-reasource'
    },
    {
        path: '/lesson/:video/view',
        name: 'lecture-video'
    },
    {
        path: '/lesson/:video/progress',
        name: 'save-course-progress'
    },
    {
        path:'/academy/course/:course/last-played',
        name:'last-played-video'
    },
    {
        path: '/academy/course/purchase/:course',
        name: 'purchase-course'
    },
    {
        path: '/academy/user/courses',
        component:UserCoursesComponent ,
        name: 'user-courses'
    },
    {
        path: '/academy/course/search/user-course',
        name: 'search-user-courses'
    },
    {
        path: '/academy/course/:course/review',
        name: 'course-review'
    },
    {
        path: '/academy/course/:course/purchase',
        name: 'purchase-free-course'
    },
    {
        path: '/disputes/save/document/:letter/:client?/:team?',
        name: 'save-letter-document'
    },
    {
        path: '/disputes/delete/document/:document/:letter/:client?/:team?',
        name: 'delete-letter-document'
    },
    {
        path: '/lesson/:lesson/video/:video/resource',
        name: 'lesson-upload-resource'
    },
    {
        path: '/lesson/:lesson/download/:video/resource',
        name: 'lesson-download-resource'
    },
    {
        path: '/academy/course/best/rated',
        name: 'courses-best-rating'
    },
    {
        path: '/academy/webiners',
        name: 'courses-webiner'
    },
    {
        path: '/subscriptions/courses/plans',
        name: 'courses-plans'
    },
    {
        path: '/subscriptions/courses/subscribe',
        name: 'courses-subscribe'
    },
    {
        path: '/subscriptions/course/cancel',
        name: 'cancel-course-subscription'
    },
    {
        path: '/subscriptions/course/swap',
        name: 'swap-course-subscription'
    },
    {
        path:'/subscriptions/course/resume',
        name:'resume-course-subscription'
    },
    {
        path:'/subscriptions/course/lifetime',
        name:'lifetime-course-subscription'
    },
    {
        path: '/dashboard/business/export/client',
        name: 'business-client-export'
    },
];
export default routes;
